import { render, staticRenderFns } from "./DynamicPage.vue?vue&type=template&id=452f33a1"
import script from "./DynamicPage.vue?vue&type=script&lang=js"
export * from "./DynamicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports